export default __webpack_public_path__ + "static/media/Loading.8619d71f.svg";